import { apiClient } from "@base/api/client";
import type { CreatePaymentMethodResponse, PaymentMethod } from "@features/membership/model/types";

/**
 * GET /82office/payment/api/methods
 * 결제 수단 목록 조회 (is_autopay_method로 메인 결제 수단 판단)
 */
export async function fetchPaymentMethods(): Promise<PaymentMethod[]> {
  const { data } = await apiClient.get<PaymentMethod[]>("/82office/payment/api/methods");
  return data;
}

/**
 * POST /82office/payment/api/methods
 * 결제 수단 추가 - hosted_page 외부 결제 링크 반환
 */
export async function createPaymentMethod(): Promise<CreatePaymentMethodResponse> {
  const { data } = await apiClient.post<CreatePaymentMethodResponse>("/82office/payment/api/methods", {
    payment_method_type: "card",
  });
  return data;
}

/**
 * DELETE /82office/payment/api/methods?payment_method_id={id}
 * 결제 수단 삭제
 */
export async function deletePaymentMethod(paymentMethodId: string): Promise<void> {
  await apiClient.delete("/82office/payment/api/methods", {
    params: { payment_method_id: paymentMethodId },
  });
}

/*
 * TanStack Query 사용 예시:
 *
 * // 조회 (useQuery)
 * import { useQuery, useQueryClient } from "@tanstack/react-query";
 * import { fetchPaymentMethods, createPaymentMethod, deletePaymentMethod } from "@features/membership/api/paymentMethods";
 *
 * const queryClient = useQueryClient();
 * const { data: methods } = useQuery({
 *   queryKey: ["paymentMethods"],
 *   queryFn: fetchPaymentMethods,
 * });
 *
 * // 생성 (useMutation) - hosted_page로 이동
 * const createMutation = useMutation({
 *   mutationFn: createPaymentMethod,
 *   onSuccess: (data) => {
 *     window.location.href = data.hosted_page;
 *   },
 * });
 *
 * // 삭제 (useMutation)
 * const deleteMutation = useMutation({
 *   mutationFn: deletePaymentMethod,
 *   onSuccess: () => {
 *     queryClient.invalidateQueries({ queryKey: ["paymentMethods"] });
 *   },
 * });
 * deleteMutation.mutate("pm_xxx");
 */
